import config from "./docs-locales.json";

export type DocsSectionKey = "overview" | "for-users" | "for-developers";

export interface DocsLocaleLabels {
  documentation: string;
  updated: string;
  previous: string;
  next: string;
  language: string;
  sections: Record<DocsSectionKey, string>;
}

export interface DocsLocale {
  code: string;
  segment: string;
  htmlLang: string;
  name: string;
  labels: DocsLocaleLabels;
}

export const DEFAULT_DOCS_LOCALE: string = config.defaultLocale;
export const DOCS_LOCALES: DocsLocale[] = config.locales;
export const DOCS_SECTIONS: DocsSectionKey[] = ["overview", "for-users", "for-developers"];

export function docsLocale(code: string): DocsLocale {
  const locale = DOCS_LOCALES.find((candidate) => candidate.code === code);
  if (!locale) throw new Error(`Unknown docs locale ${code}`);
  return locale;
}

/**
 * The canonical route of one docs page. `slug` is empty for the section index:
 * `/docs/` in English, `/ja/docs/` for Japanese, and so on.
 */
export function docsRoute(localeCode: string, slug: string): string {
  const { segment } = docsLocale(localeCode);
  const base = segment ? `/${segment}/docs/` : "/docs/";
  return slug ? `${base}${slug}/` : base;
}

/** Localized chrome label; `{date}` is replaced for the updated line. */
export function docsLabel(localeCode: string, key: keyof DocsLocaleLabels, date?: string): string {
  const value = docsLocale(localeCode).labels[key];
  if (typeof value !== "string") return "";
  return date ? value.replace("{date}", date) : value;
}

export function docsSectionLabel(localeCode: string, section: DocsSectionKey): string {
  return docsLocale(localeCode).labels.sections[section];
}
